import SubmitFormPresenter from "../../submit-form/presenter/submit-form.js";

export default class OrderSubmit extends SubmitFormPresenter {
  constructor({
    formElement,
    requestUrl,
    requestMethod,
    submitStyle,
    callbacks,
    action
  }) {
    super({
      formElement,
      requestUrl,
      requestMethod,
      submitStyle,
      callbacks,
      action
    });
  }

  setRules(rules) {
    this._elements = [];
    this._elementsViews = {};

    this._rules = rules;
    this._setElements(this._formView.getElement());
    this._initModel();
  }
}
